module.exports = __webpack_public_path__ + "static/media/home_splash.4d438f5c.png";